"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MenuLink;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRouterDom = require("react-router-dom");
var _excluded = ["disabled"];
var useStyles = (0, _makeStyles.default)({
  accountMenuIcon: {
    marginRight: 0
  }
});
function MenuLinkItem(_ref) {
  var disabled = _ref.disabled,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  if (disabled) {
    return /*#__PURE__*/_react.default.createElement(_material.MenuItem, (0, _extends2.default)({}, rest, {
      disabled: true
    }));
  }
  return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_material.MenuItem, (0, _extends2.default)({}, rest, {
    component: _reactRouterDom.Link
  })));
}
function MenuLink(_ref2) {
  var closeMenu = _ref2.closeMenu,
    disabled = _ref2.disabled,
    Icon = _ref2.Icon,
    id = _ref2.id,
    primaryText = _ref2.primaryText,
    primaryTextKey = _ref2.primaryTextKey,
    secondaryText = _ref2.secondaryText,
    secondaryTextKey = _ref2.secondaryTextKey,
    to = _ref2.to;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(MenuLinkItem, {
    disabled: disabled,
    id: id,
    onClick: closeMenu,
    to: to
  }, Icon && /*#__PURE__*/_react.default.createElement(_material.ListItemIcon, {
    className: classes.accountMenuIcon
  }, /*#__PURE__*/_react.default.createElement(Icon, null)), /*#__PURE__*/_react.default.createElement(_material.ListItemText, {
    primary: primaryTextKey && /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: primaryTextKey
    }) || primaryText,
    secondary: secondaryTextKey && /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: secondaryTextKey
    }) || secondaryText
  }));
}